import { render, staticRenderFns } from "./courseClassModal.vue?vue&type=template&id=ec41239a&scoped=true&"
import script from "./courseClassModal.vue?vue&type=script&lang=js&"
export * from "./courseClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec41239a",
  null
  
)

export default component.exports